import { useState } from "react";
import { faqs, trustPoints } from "@/mocks/archive";

export default function TrustFaq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background-100 border-t border-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* 左：信源承诺（醒目） */}
          <div className="lg:col-span-5">
            <div className="rounded-lg bg-background-900 p-6 md:p-8 text-background-50">
              <p className="flex items-center gap-2 text-sm font-medium text-accent-300">
                <i className="ri-shield-check-line" />
                信源与整理原则
              </p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-background-50">
                我们如何看待全网黑料
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-300">
                旧料考据不是情绪站队，也不靠捏造赚流量。以下是整理与核实这些早年黑历史与历史遗留时遵循的底线。
              </p>

              <div className="mt-6 flex flex-col gap-4">
                {trustPoints.map((t) => (
                  <div key={t.title} className="flex items-start gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-950">
                      <i className={t.icon + " text-lg"} />
                    </span>
                    <div>
                      <p className="font-semibold text-background-50">{t.title}</p>
                      <p className="mt-0.5 text-sm leading-relaxed text-background-300">{t.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 右：FAQ 手风琴 */}
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-question-line" />
              常见问题 · 阅读须知
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于旧料考古，你想问的都在这里
            </h2>

            <div className="mt-6 flex flex-col gap-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-semibold text-foreground-900">{f.q}</span>
                      <i
                        className={
                          "text-foreground-400 transition-transform duration-200 " +
                          (isOpen ? "ri-subtract-line" : "ri-add-line")
                        }
                      />
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 border-t border-background-100 pt-4">
                        {f.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}